import { useContext } from "react";
import { FuelPriceContext } from "../context";

export const useFuelPrice = () => useContext(FuelPriceContext);
